import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=5229677d&scoped=true"
import script from "./UploadDocuments.vue?vue&type=script&lang=js"
export * from "./UploadDocuments.vue?vue&type=script&lang=js"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=5229677d&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5229677d",
  null
  
)

export default component.exports